import React from 'react';
import { palettes } from '@indigo-ag/component-module';

import { createStylesHook } from 'shared';

const useStyles = createStylesHook({
  separator: {
    backgroundColor: palettes.neutral['200'],
    height: 1,
    width: '100%'
  }
});

export const Separator: React.FunctionComponent = () => {
  /**
   * Styles
   */
  const classes = useStyles();

  return <div className={classes.separator} />;
};
